<template lang="pug">
b-form-select(
  :value="value"
  :size="size"
  :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
  @input="handleInput"
  )
  //- option(:value="('' || null)"  :disabled="disabledAll" selected) {{ $t("message.select_option") }}
  option(value="" v-if="value == ''"  :disabled="disabledAll" selected) {{ $t("message.select_option") }}
  option(:value="null" v-else-if="value == null || haveNull"  :disabled="disabledAll" selected) {{ $t("message.select_option") }}
  option(v-for="option in options" v-if="themeContentId != option.content_id" :value="option.content_id") {{ option.content_id }}
</template>

<script>
import config from "@/config";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    disabledAll: {
      type: Boolean,
      default: true
    },
    themeCode: {
      type: String,
      default: ''
    },
    themeContentId: {
      type: String,
      default: ''
    },
    haveNull: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    options: [],
    feedback: {
      success: true,
      status: ""
    }
  }),
  mounted() {
    this.getThemeContent();
  },
  methods: {
    getThemeContent() {
      let url = config.getThemeContentListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        theme_code: this.themeCode,
        theme_content_group: ""
      };
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.options = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>
